


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { EscalatedAlert, EventType, Product, Vat } from '@/api';
import VatChartAdmin from '@/components/charts/vat-chart-admin.vue';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';
import StatusChangeModal from './status-change-modal.vue';
import EscalatedAlertCardHeader from './escalated-alert-card-header.vue';
import InformationRow from '@/components/display/information-row.vue';
import LinkRow from '@/components/display/information-rows/link-row.vue';
import { ProductApiService } from '@/services/product-service';
import Toast from '@/components/display/toast.vue';
import { VatDashboard } from '@/pages/account/products/milk/vats/models/vat-dashboard';
import powerIcon from '../../../../assets/svgs/power.svg';
import vatNotInUseIcon from '../../../../assets/svgs/vat_not_in_use.svg';

@Component({
	components: {
		LinkRow,
		TooltipButton,
		VatChartAdmin,
		InformationRow,
		StatusChangeModal,
		EscalatedAlertCardHeader,
	},
})
export default class EscalatedAlertInfoPanel extends Vue {
	@Prop({ type: Object })
	public alert!: EscalatedAlert;

	@Prop({ type: Object })
	public product!: Product;

	@Prop({ type: Object })
	public vat!: Vat;

	@Prop({ type: Object })
	public event!: EventType;

	public dash: VatDashboard | null = null;
	public toast: Toast = new Toast();
	public productApi: ProductApiService = new ProductApiService();

	public warnings: Array<{ tooltip: string, showWarning: boolean, icon: string, altText: string }> = [];

	public get showWarnings(): boolean {
		return this.warnings.some(warning => warning.showWarning);
	}

	public get entityText(): string {
		return this?.vat ? `${this?.alert?.entity_type}: ${this?.vat.label}` : `${this?.alert?.entity_type}: ${this?.alert?.entity_id}`
	}

	public async mounted() {
		this.loadDash();
	}

	public async loadDash() {
		if (this.alert.product_id == undefined || this.alert.entity_id == undefined) {
			this.toast.makeToast('Product or Entity id is undefined', 'Error', 'danger');
			return;
		}

		const { dash, errorMessage } = await this.productApi.getDashByProductId(this.alert.product_id)
		if (errorMessage) {
			this.toast.makeToast(errorMessage, 'Failed to get warnings', 'danger');
		} else {
			this.dash = dash?.data?.filter(dashboard => dashboard.id == this.alert.entity_id)[0];
		}
	}

	@Watch('vat')
	@Watch('dash')
	public setWarnings() {
		this.warnings = [
			{
				tooltip: "This power is currently off on the transceiver",
				showWarning: this.dash?.power?.value == "Off",
				icon: powerIcon,
				altText: "Power Off Indicator",
			},
			{
				tooltip: "This vat state is currently in not used or non supply",
				showWarning: this.vat?.state == "nonSupply" || this.vat?.state == "notUsed",
				icon: vatNotInUseIcon,
				altText: "Vat Not In Use Indicator",
			},
		]
	}
}
